import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabs-view',
  templateUrl: './tabs-view.component.html',
  styleUrls: ['./tabs-view.component.css']
})
export class TabsViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
